"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var customizer_navigation_1 = require("../../controls/customizer-navigation");
wp.customize.controlConstructor['epsilon-customizer-navigation'] = wp.customize.Control.extend({
    ready: function () {
        var control = this;
        new customizer_navigation_1.EpsilonCustomizerNavigation(control);
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/vendors/epsilon-framework/customizer/extenders/controls/customizer-navigation.ts
// module id = 15
// module chunks = 0